import { JsonItem } from "../../../secure/list-management/scripts/list-management.objects";
import { DataViewer } from "./data-viewer";

export class TableExport {
    filename: string;
    viewArray: DataViewer[];

    constructor(filename: string, viewArray: DataViewer[]) {
        this.filename = filename;
        this.viewArray = viewArray;
    }

    initialize(pickLists: JsonItem[]) {
        this.viewArray.forEach(view => view.initialize(pickLists));
    }

    createCsvData(objArray: any[]): string {
        let csv = "";

        let columnNames: string[] = this.viewArray.map(item => item.displayName);
        csv += columnNames.join(",");

        objArray.forEach(row => {
            csv += "\n";
            let rowData: string[] = this.viewArray.map(view => view.getDisplayValue(row));
            // replace any " value to avoid issues in creating CSV
            let regex: RegExp = /"/g;
            rowData = rowData.map(item => item.replace(regex, "'"));

            // warp each value in "..." to ensure no issues with commas
            rowData = rowData.map(item => `"${item}"`);
            csv += rowData.join(",");
        });

        return csv;
    }
}